import {EvenementCalendrier} from './evenement-calendrier.model';
import {CodeDesignation} from 'sigale-angular';
import {TypeEvenementCalendrier} from './type-evenement-calendrier.model';

export class Reservation extends EvenementCalendrier {
	bureauId: number;
	nomBureau: string;
	ilotId: number;
	nomIlot: string;
	couleurIlot: string;

	constructor(
		id: number,
		date: Date,
		duree: CodeDesignation,
		bureauId: number,
		nomBureau: string,
		ilotId: number,
		nomIlot: string,
		couleurIlot: string) {
		super(id, date, duree);
		this.bureauId = bureauId;
		this.nomBureau = nomBureau;
		this.ilotId = ilotId;
		this.nomIlot = nomIlot;
		this.couleurIlot = couleurIlot;
	}

	getType(): TypeEvenementCalendrier {
		return TypeEvenementCalendrier.RESERVATION;
	}
}
